export const extractDetailsFromBase64 = (base64: string) => {
  //
  if (!base64) {
    return {imageType: null, url: null};
  }
  const parts = base64.split(',');
  const url = parts[1];
  let mid = parts[0].split('/')[1];
  const imageType = mid.split(';')[0];
  return {imageType, url};
};

export const mergeBase64toImage = (imageType, url) => {
  return `data:image/${imageType};base64,${url}`;
};
